import { Star } from "lucide-react";

export const TestimonialCard = ({ testimonial }) => {
  const { client_name, company, content, rating, project_type } = testimonial;

  return (
    <div className="testimonial-card bg-[#121212] border border-[#2A2A2A] p-8 card-hover" data-testid="testimonial-card">
      {/* Stars */}
      <div className="flex gap-1 mb-4">
        {[...Array(5)].map((_, i) => (
          <Star
            key={i}
            size={18}
            className={i < rating ? "star-filled fill-current" : "star-empty"}
          />
        ))}
      </div>

      {/* Content */}
      <p className="text-[#A1A1AA] text-base leading-relaxed mb-6 relative z-10">
        "{content}"
      </p>

      {/* Author */}
      <div className="flex items-center justify-between">
        <div>
          <p className="font-['Oswald'] text-white font-semibold">{client_name}</p>
          {company && <p className="text-[#A1A1AA] text-sm">{company}</p>}
        </div>
        {project_type && (
          <span className="text-[#7ED4C6] text-xs uppercase tracking-wider border border-[#7ED4C6]/30 px-3 py-1">
            {project_type}
          </span>
        )}
      </div>
    </div>
  );
};
